export function FixedTop({children}) {

    return (
        <div className='container justify-content-around position-relative border-bottom bg-tertiary text-white fw-bold text-center p-3 z-1 ps-5 pe-5 lh-1'>
            {children}
        </div>
    );
}